import { meteringLocationNumberLength } from "./validateMeteringLocationNumber";

export type MeteringOrMarketLocationType =
  "meteringLocation" | "marketLocation";

/**
 * Mirrors the backend discriminator: a Mess- oder Marktlokation is a
 * Messlokation exactly when its number has Messlokation length. No "neither"
 * case — every number is one or the other.
 */
export function resolveMeteringOrMarketLocationType(
  number: string
): MeteringOrMarketLocationType {
  return number.length === meteringLocationNumberLength
    ? "meteringLocation"
    : "marketLocation";
}
